import { render, staticRenderFns } from "./PricingBox.vue?vue&type=template&id=5de2c9d3"
import script from "./PricingBox.vue?vue&type=script&lang=js"
export * from "./PricingBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports